import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faGlobe, faHashtag, faSave, faEdit, faTimes } from '@fortawesome/free-solid-svg-icons';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        suppliers: [],
        errors: []
    }
    changeValue = (e) => {
        const state = this.state.suppliers;
        state[e.target.name] = e.target.value;
        this.setState({ suppliers: state });
    };
    errorVerify(elemento) {
        return this.state.errors.indexOf(elemento) !== -1;
    }
    sendData = (e) => {
        e.preventDefault();
        const name = document.getElementById('name').value;
        const address = document.getElementById('address').value;
        const email = document.getElementById('email').value;
        const postal_code = document.getElementById('postal_code').value;
        const full_name_billing = document.getElementById('full_name_billing').value;
        const address_billing = document.getElementById('address_billing').value;
        const phone_billing = document.getElementById('phone_billing').value;
        const tax_number_billing = document.getElementById('tax_number_billing').value;
        var errors = [];
        if (!name) { errors.push("error_name"); }
        if (!address) { errors.push("error_address"); }
        if (!email) { errors.push("error_email"); }
        if (!postal_code) { errors.push("error_postal_code"); }
        if (!full_name_billing) { errors.push("error_full_name_billing"); }
        if (!address_billing) { errors.push("error_address_billing"); }
        if (!phone_billing) { errors.push("error_phone_billing"); }
        if (!tax_number_billing) { errors.push("error_tax_number_billing"); }
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        console.log(formData);
        Swal.showLoading();
        authAxios.post("suppliers/update", formData)
            .then((dataResult) => {
                console.log(dataResult)
                Swal.close();
                Swal.fire(
                    'Suppliers!',
                    dataResult.data.msj,
                    'success'
                )
                this.props.history.push("/MasterSuppliers");
            })
            .catch(console.log)
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("suppliers/view/" + this.props.match.params.id)
            .then((dataResult) => {
                console.log(dataResult);
                this.setState({ suppliers: dataResult.data.result, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { load, suppliers } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>UPDATE SUPPLIER</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.sendData} id="form">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <hr style={{ marginBottom: 0, marginTop: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>SUPPLIER INFORMATION</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-5">
                                                    <input type="hidden" name="id_supplier" value={this.props.match.params.id} />
                                                    <input type="hidden" name="user_id" id="user_id" value={window.localStorage.getItem('idusuario')} />
                                                    <label htmlFor="name">Name</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="name" id="name" defaultValue={suppliers.NAME}
                                                        className={((this.errorVerify("error_name")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Name" aria-describedby="helpId"
                                                        onChange={this.changeValue}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Please enter Supplier Name</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="address">Address</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="address" id="address" defaultValue={suppliers.ADDRESS}
                                                        className={((this.errorVerify("error_address")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Address" aria-describedby="helpId"
                                                        onChange={this.changeValue} />
                                                    <small id="helpId" className="invalid-feedback">Please enter Supplier Address</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="phone">Phone</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="phone" id="phone" defaultValue={suppliers.PHONE}
                                                            className={((this.errorVerify("error_phone")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Phone" aria-describedby="helpId"
                                                            onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Supplier Phone</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-5">
                                                    <label htmlFor="website">Website</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faGlobe} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="website" id="website" defaultValue={suppliers.WEBSITE}
                                                            className={((this.errorVerify("error_website")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Website" aria-describedby="helpId"
                                                            onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Supplier Website</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="email">Email</label>
                                                    <div className={((this.errorVerify("error_email")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faAt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="email" id="email" defaultValue={suppliers.EMAIL}
                                                            className={((this.errorVerify("error_email")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Email" aria-describedby="helpId"
                                                            onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Supplier Email</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="postal_code">Postal Code</label>
                                                    <div className={((this.errorVerify("error_postal_code")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="postal_code" id="postal_code" defaultValue={suppliers.POSTAL_CODE}
                                                            className={((this.errorVerify("error_postal_code")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Postal Code" aria-describedby="helpId"
                                                            onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Supplier Postal Code</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>BILLING INFORMATION</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="full_name_billing">Full Name</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="full_name_billing" id="full_name_billing" defaultValue={suppliers.FULL_NAME_BILLING}
                                                        className={((this.errorVerify("error_full_name_billing")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Full Name" aria-describedby="helpId"
                                                        onChange={this.changeValue} />
                                                    <small id="helpId" className="invalid-feedback">Please enter Full Name</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="address_billing">Address</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="address_billing" id="address_billing" defaultValue={suppliers.ADDRESS_BILLING}
                                                        className={((this.errorVerify("error_address_billing")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Address" aria-describedby="helpId"
                                                        onChange={this.changeValue} />
                                                    <small id="helpId" className="invalid-feedback">Please enter Address</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="phone_billing">Phone</label>
                                                    <div className={((this.errorVerify("error_phone_billing")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="phone_billing" id="phone_billing" defaultValue={suppliers.PHONE_BILLING}
                                                            className={((this.errorVerify("error_phone_billing")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Phone" aria-describedby="helpId"
                                                            onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Phone</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="tax_number_billing">Tax Number</label>
                                                    <div className={((this.errorVerify("error_tax_number_billing")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="tax_number_billing" id="tax_number_billing" defaultValue={suppliers.TAX_NUMBER_BILLING}
                                                            className={((this.errorVerify("error_tax_number_billing")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Tax Number" aria-describedby="helpId"
                                                            onChange={this.changeValue} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Tax Number</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Update</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterSuppliers"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancel</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;